import { apiClient } from '@/shared/api';
import type { BetaFeatureItem, BetaFeatureListResponse, BetaFeatureUpdate } from './types';

/**
 * Возвращает реестр бета-функций с их состоянием.
 * Доступен любому аутентифицированному пользователю: по состоянию функции интерфейс решает,
 * показывать её или нет.
 */
export const fetchBetaFeatures = async (): Promise<BetaFeatureListResponse> => {
  const { data } = await apiClient.get<BetaFeatureListResponse>('/beta-feature');
  return data;
};

/** Переключает бета-функцию сразу для всех пользователей; требует разрешения ADMIN_BETA_FEATURE. */
export const updateBetaFeature = async ({ code, isEnabled }: BetaFeatureUpdate): Promise<BetaFeatureItem> => {
  const { data } = await apiClient.put<BetaFeatureItem>(`/beta-feature/${code}`, { isEnabled });
  return data;
};
